<template>
  <form :class="classes()" @submit.prevent="handleSubmit">
    <Copy v-if="statusCode === 401" color="supportDanger" centered bold responsive>
      {{ $t('profile.forms.error.generics') }}
    </Copy>

    <div v-if="!legals.privacyStatement.isCurrent" :class="`${el}__inputArea`">
      <Copy>
        {{
          $t('profile.legal.form.newLegals.text')[0] +
          formatDate(legals.privacyStatement.date) +
          $t('profile.legal.form.newPrivacyStatement')
        }}
        <Link :to="ROUTE_PRIVACY" weight="regular" external>
          {{ $t('legalsform.privacyStatement') }}
        </Link>
        {{ $t('profile.legal.form.newLegals.text')[1] }}
      </Copy>

      <BaseCheckbox
        name="privacyStatement"
        v-model="formFields.privacyStatement.value"
        :error="formFields.privacyStatement.error"
        @input="clearError(formFields.privacyStatement)"
      >
        <span slot="label">
          {{ $t('profile.legal.form.checkbox', { type: $t('legalsform.privacyStatement') }) }}
        </span>
      </BaseCheckbox>
    </div>

    <div v-if="!legals.privacyStatement.isCurrent" :class="`${el}__divider`">
      <Divider />
    </div>

    <div :class="`${el}__buttonRow`">
      <Button :label="$t('profile.legal.form.button.next')" :loading="isLoading" submit small />
    </div>
  </form>
</template>

<script>
import Link from '@/objects/Link';
import BaseCheckbox from '@/objects/Forms/BaseCheckbox';
import Button from '@/objects/Button';
import Divider from '@/objects/Divider';
import Copy from '@/objects/Copy';

import Vue from 'vue';
import { ROUTE_API_UPDATE_CONSENTS } from '@/constants/apiRoutes';
import { ROUTE_PRIVACY } from '@/constants/routes';

import { validateForm } from '@/helpers/formValidation';
import { formatDate } from '@/helpers/formatter';
import { USER_CHANGE_REQUEST } from '@/store/actions/user';

export default {
  name: 'LegalForm',
  props: {
    legals: Object,
  },

  components: {
    Divider,
    Copy,
    Button,
    BaseCheckbox,
    Link,
  },

  created() {
    this.setRequired();
  },

  data() {
    return {
      isLoading: false,
      statusCode: '',
      headline: '',
      ROUTE_PRIVACY,
      formatDate,
      formFields: {
        privacyStatement: {
          value: 0,
          error: null,
          required: null,
        },
      },
      el: 'c-legalForm',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
        };
      },
    };
  },

  methods: {
    handleSubmit(e) {
      this.isLoading = true;
      const { isValid } = validateForm(e.target.elements, this.formFields);

      if (isValid) {
        let consents = {};

        if (!this.legals.privacyStatement.isCurrent) {
          consents.privacyStatement = this.formFields.privacyStatement.value;
        }

        Vue.axios
          .post(ROUTE_API_UPDATE_CONSENTS, consents)
          .then((response) => {
            this.statusCode = response.status;
            this.$store.dispatch(USER_CHANGE_REQUEST, response.data);
            this.$emit('accepted');
            this.isLoading = false;
          })
          .catch((error) => {
            const {
              data: { errors },
              status,
            } = error.response;

            this.statusCode = status;

            if (status === 422) {
              Object.keys(errors).map((error) => {
                const type = errors[error][0];
                this.formFields[error].error = this.$t(`profile.legal.form.error.${error}.${type}`);
              });
            }
            this.isLoading = false;
          });
      } else {
        this.isLoading = false;
      }
    },

    setRequired() {
      if (!this.legals.privacyStatement.isCurrent) {
        this.formFields.privacyStatement.required = this.$t(
          'profile.legal.form.error.privacyStatement.required'
        );
      } else {
        this.formFields.privacyStatement.required = null;
      }
    },

    clearError(field) {
      field.error = null;
    },
  },
};
</script>
